import { render, staticRenderFns } from "./peopleTable.vue?vue&type=template&id=6ca53051&scoped=true"
import script from "./peopleTable.vue?vue&type=script&lang=js"
export * from "./peopleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca53051",
  null
  
)

export default component.exports